module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/leromain.844a954.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/leromain.jpg
// module id = k4BJ
// module chunks = 0